import React from 'react'
import { ImageWrapperProps } from './types'
import './index.scss'

export const ImageWrapper: React.FC<ImageWrapperProps> = ({ desktopProperties, mobileProperties, alt, href }) => {
  const LinkUrlWrapper: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    if (href) return <a href={href}>{children}</a>

    return children
  }

  return (
    <div className={`image-wrapper`}>
      <LinkUrlWrapper>
        <>
          {desktopProperties && (
            <img
              loading={desktopProperties.lazy ? 'lazy' : 'eager'}
              className="image-item desktop"
              src={desktopProperties.src}
              alt={alt}
              height={desktopProperties.height}
              width={desktopProperties.width}
            />
          )}
          {mobileProperties && (
            <img
              loading={mobileProperties.lazy ? 'lazy' : 'eager'}
              className="image-item mobile"
              src={mobileProperties.src}
              alt={alt}
              height={mobileProperties.height}
              width={mobileProperties.width}
            />
          )}
        </>
      </LinkUrlWrapper>
    </div>
  )
}
